module.exports = __webpack_public_path__ + "3c6846281b33c8e9347637359bb6656e.MP3";